import React from "react";

function WarningIcon({ className }: { className: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24">
      <path d="M12 2 1 21h22L12 2zm0 5.5 6.9 11.9H5.1L12 7.5z" />
      <rect x="11" y="10" width="2" height="5" />
      <rect x="11" y="16.5" width="2" height="2" />
    </svg>
  );
}

export { WarningIcon };
